import RestClient from './RestClient';
import { Period } from '../../models';

class Periods extends RestClient {
    constructor() {
        super({
            "model": Period,
            "entryPoint": "period",
            "resource": "period",
            "resources": "periods",
            "id": "id"
        });
    }
}

const PeriodsApi = new Periods();

export default PeriodsApi;
